export default {"src":"/_next/static/media/icon_footer_store_tungsten.2cbb5b72.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};